import { render, staticRenderFns } from "./ConformityDetailCard.vue?vue&type=template&id=30cfd9c0&scoped=true&"
import script from "./ConformityDetailCard.vue?vue&type=script&lang=js&"
export * from "./ConformityDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./ConformityDetailCard.vue?vue&type=style&index=0&id=30cfd9c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cfd9c0",
  null
  
)

export default component.exports